import {
  BTC,
  ETH,
  JITO_SOL,
  JUP,
  MER,
  M_SOL,
  PYTH,
  RAY,
  RENDER,
  SBR,
  SO_FTT,
  SRM,
  USDC,
  USDS,
  USDT,
  VND,
  WBTC,
} from "@renec-foundation/relend-adapter"
import {
  APS,
  BNB,
  CE_USD,
  GAST,
  NGN,
  PI,
  PLUS1,
  PROP,
  REL,
  RELEND,
  RENEC,
  RE_BNB,
  RE_BTC,
  RE_ETH,
  RE_NGN,
  RE_SOL,
  RE_USD,
  RE_VND,
  SOL,
  ST_RENEC,
  S_REL,
  VE_REL,
} from "./constants"

export const isSymbolWhitelisted = (symbol: string, listToCheck: string[]) => listToCheck.includes(symbol)

// reserves
export const WHITELIST_SYMBOL_MY_SUPPLY_RESERVES = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,
  PLUS1,
  APS,
  ST_RENEC,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,

  // SOLEND
  USDS,
]
export const WHITELIST_SYMBOL_SUPPLY_RESERVES = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,
  PLUS1,
  APS,
  ST_RENEC,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
  REL,

  // SOLEND
  USDS,
]
export const WHITELIST_SYMBOL_MY_BORROW_RESERVES = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
]
export const WHITELIST_SYMBOL_BORROW_RESERVES = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  SOL,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
  REL,
]

// actions
export const WHITELIST_SYMBOL_SUPPLY_ACTIONS = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,
  PLUS1,
  APS,
  ST_RENEC,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,

  // SOLEND
  USDS,
]
export const WHITELIST_SYMBOL_WITHDRAW_ACTIONS = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,
  PLUS1,
  APS,
  ST_RENEC,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,

  // SOLEND
  USDS,
]
export const WHITELIST_SYMBOL_BORROW_ACTIONS = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
]
export const WHITELIST_SYMBOL_REPAY_ACTIONS = [
  RE_SOL,
  RE_BNB,
  PI,
  RE_VND,
  RE_NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
]

// Token infos
export const WHITELIST_TOKEN_INFO_SYMBOLS = [
  RE_SOL,
  RE_BNB,
  RE_VND,
  RE_NGN,
  SOL,
  BNB,
  PROP,
  S_REL,
  NGN,
  RENEC,
  RE_USD,
  RE_ETH,
  RE_BTC,
  GAST,
  PLUS1,
  APS,
  REL,
  VE_REL,
  RELEND,
  CE_USD,
  ST_RENEC,

  // Solana
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  VND,
  USDT,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
  REL,

  // SOLEND
  USDS,
]
